import requests from './request';

// 核销
export const reqWriteOff = data => {
    return requests({ url: '/mallboonroster/mallboonrosterUse', method: 'post', data });
};

// 账单
export const reqBill = params => {
    return requests({ url: '/mallboonroster/getMallBoonRoster', method: 'get', params });
};

// 是否商家
export const reqMerchant = (params) => {
    return requests({ url: '/mallorg/selectData', method: 'get', params });
};

// 已售出优惠券账单
export const reqSoldList = params => {
    return requests({ url: '/mallboonroster/getMallBoonRoster', method: 'get', params });
};

// 核销优惠券
export const reqWriteOffList = params => {
    return requests({ url: '/mallboonroster/getMarketMallBoonRoster', method: 'get', params });
};
